export const getSuperAdminMenu = (urlPrefix) => [
    {
        label: "Dashboard",
        icon: "fa fa-dashboard",
        to: "/",
    },
    {
        label: "Server Monitoring",
        icon: "fa fa-server",
        to: `${urlPrefix}/monitoring`,
    },
    {
        label: "Manage Users",
        icon: "fa fa-user",
        children: [
            { label: "Create User", icon: "fa fa-plus", to: `${urlPrefix}/create-user` },
            { label: "User List", icon: "fa fa-list", to: `${urlPrefix}/user-list` },
            { label: "Credit History", icon: "fa fa-history", to: `${urlPrefix}/credits-history` },
            { label: "Call Detail Records", icon: "fa fa-phone", to: `${urlPrefix}/call-detail-records` },
            { label: "Reseller Summary", icon: "fa fa-list", to: `${urlPrefix}/reseller-summary` },
            { label: "User Settings List", icon: "fa fa-list", to: `${urlPrefix}/user-settings` },
            { label: "Voice Plan Logs", icon: "fa fa-history", to: `${urlPrefix}/voice-plan-logs` },
        ],
    },
    {
        label: "Manage Sub-Super Admin",
        icon: "fa fa-user",
        children: [
            { label: "Create Sub-Super Admin", icon: "fa fa-plus", to: `${urlPrefix}/sub-super-admin/create-user` },
            { label: "Sub-Super Admin List", icon: "fa fa-list", to: `${urlPrefix}/sub-super-admin/user-list` },
        ],
    },
    {
        label: "Manage Campaign",
        icon: "fa fa-bullhorn",
        children: [
            { label: "Voice Campaign Summary", icon: "fa fa-table", to: `${urlPrefix}/voice-superadmin-campaign-summary` },
            { label: "Prompt Voice Campaign Summary", icon: "fa fa-table", to: `${urlPrefix}/prompt-voice-superadmin-campaign-summary` },
            { label: "Historical Campaign Summary", icon: "fa fa-list", to: `${urlPrefix}/historical-campaign-summary-superadmin` },
            { label: "Download Report", icon: "fa fa-table", to: `${urlPrefix}/download-report` },
            { label: "Report Scheduling", icon: "fa fa-calendar-check-o", to: `${urlPrefix}/report-scheduling` },
            { label: "Manage Campaigns", icon: "fa fa-bullhorn", to: `${urlPrefix}/manage-campaigns-superadmin` },
            { label: "Campaign Operations", icon: "fa fa-tasks", to: `${urlPrefix}/campaign-operations` },
            { label: "CvC Summary", icon: "fa fa-table", to: `${urlPrefix}/cvc-summary` },
            { label: "Inbound Summary", icon: "fa fa-table", to: `${urlPrefix}/inbound-superadmin-campaign-summary` },
            { label: "View Voice Base", icon: "fa fa-table", to: `${urlPrefix}/view-voice-base` },
            { label: "Custom IVR List", icon: "fa fa-table", to: `${urlPrefix}/ivr-list` },
            { label: "Webhook List", icon: "fa fa-table", to: `${urlPrefix}/webhook-list` },
            { label: "SMS Webhook List", icon: "fa fa-table", to: `${urlPrefix}/sms-webhook-list` },
        ],
    },
    {
        label: "Manage CLI",
        icon: "fa fa-phone",
        children: [
            { label: "Upload CLI", icon: "fa fa-upload", to: `${urlPrefix}/upload-cli` },
            { label: "Allocate CLI", icon: "fa fa-tasks", to: `${urlPrefix}/allocate-cli` },
            { label: "Archived CLI List", icon: "fa fa-archive", to: `${urlPrefix}/archived-cli` },
            { label: "CLI List", icon: "fa fa-list", to: `${urlPrefix}/cli-list` },
            { label: "Pilot no. CLI", icon: "fa fa-list", to: `${urlPrefix}/cli-pilot-list` },
        ],
    },
    {
        label: "Manage Module",
        icon: "fa fa-tasks",
        children: [
            { label: "ACL Module List", icon: "fa fa-table", to: `${urlPrefix}/module` },
            { label: "Create New ACL", icon: "fa fa-plus", to: `${urlPrefix}/create-acl-settings` },
            { label: "ACL Setting List", icon: "fa fa-table", to: `${urlPrefix}/acl-settings` },
        ],
    },
    {
        label: "Manage API CLI",
        icon: "fa fa-tasks",
        children: [
            { label: "Upload Api CLI", icon: "fa fa-plus-circle", to: `${urlPrefix}/upload-cli-api` },
            { label: "Archived Api CLI List", icon: "fa fa-table", to: `${urlPrefix}/archived-api-cli` },
            { label: "Api CLI List", icon: "fa fa-table", to: `${urlPrefix}/cli-api-list` },
            { label: "Api Pilot no. CLI", icon: "fa fa-table", to: `${urlPrefix}/cli-api-pilot-list` },
        ],
    },
    {
        label: "Manage Api Key",
        icon: "fa fa-key",
        children: [
            { label: "Api Summary", icon: "fa fa-table", to: `${urlPrefix}/api-key-summary-list` },
            { label: "Api Historical Summary", icon: "fa fa-table", to: `${urlPrefix}/api-key-historical-summary-list` },
        ],
    },
    {
        label: "Manage Groups",
        icon: "fa fa-users",
        children: [
            { label: "Create Group", icon: "fa fa-plus", to: `${urlPrefix}/create-group` },
            { label: "Group List", icon: "fa fa-list", to: `${urlPrefix}/group-list` },
            { label: "Bulk Group Delete", icon: "fa fa-list", to: `${urlPrefix}/bulk-update-group` },
            { label: "Bulk Group Add", icon: "fa fa-list", to: `${urlPrefix}/bulk-addition-group` },
        ],
    },
    {
        label: "Manage Locations",
        icon: "fa fa-map-marker",
        children: [
            { label: "Create Location", icon: "fa fa-plus", to: `${urlPrefix}/create-location` },
            { label: "Location List", icon: "fa fa-list", to: `${urlPrefix}/location-list` },
            { label: "Bulk Location Delete", icon: "fa fa-list", to: `${urlPrefix}/bulk-location-delete` },
            { label: "Bulk Location Add", icon: "fa fa-list", to: `${urlPrefix}/bulk-addition-location` },
        ],
    },
    {
        label: "Manage Dialers",
        icon: "fa fa-pencil",
        children: [
            { label: "Search Dialer", icon: "fa fa-search", to: `${urlPrefix}/search-dialer` },
            { label: "Create Dialer", icon: "fa fa-plus", to: `${urlPrefix}/create-dialer` },
            { label: "Dialer List", icon: "fa fa-list", to: `${urlPrefix}/dialer-list` },
            { label: "Dialer Usage", icon: "fa fa-list", to: `${urlPrefix}/dialer-usage` },
        ],
    },
    {
        label: "Manage Trunks",
        icon: "fa fa-phone",
        children: [
            { label: "Create Trunk", icon: "fa fa-plus", to: `${urlPrefix}/create-trunk` },
            { label: "Trunk List", icon: "fa fa-list", to: `${urlPrefix}/trunk-list` },
        ],
    },
    {
        label: "Voice Plans",
        icon: "fa fa-wifi",
        children: [
            { label: "Add Voice Plan", icon: "fa fa-plus", to: `${urlPrefix}/add-voice-plan` },
            { label: "View Voice Plans", icon: "fa fa-list", to: `${urlPrefix}/voice-plans` },
        ],
    },
    {
        label: "TTS Plans",
        icon: "fa fa-wifi",
        children: [
            { label: "Add TTS Plan", icon: "fa fa-plus", to: `${urlPrefix}/add-tts-plan` },
            { label: "View TTS Plans", icon: "fa fa-list", to: `${urlPrefix}/tts-plans` },
        ],
    },
    {
        label: "Voice Library",
        icon: "fa fa-music",
        children: [
            { label: "All Prompts", icon: "fa fa-check", to: `${urlPrefix}/all-voice-files` },
            { label: "Prompts for Approval", icon: "fa fa-check", to: `${urlPrefix}/voice-files` },
            { label: "TTS List", icon: "fa fa-check", to: `${urlPrefix}/tts-list` },
        ],
    },
    {
        label: "Number Action",
        icon: "fa fa-sliders",
        children: [
            { label: "Manage Blacklist-DND", to: `${urlPrefix}/add-blacklist-dnd` },
            { label: "Manage Bulk Blacklist-DND", to: `${urlPrefix}/bulk-blacklist-dnd` },
            { label: "View Blacklist", to: `${urlPrefix}/voice-blacklist` },
            { label: "Add Whitelist", to: `${urlPrefix}/add-whitelist` },
            { label: "View Whitelist", to: `${urlPrefix}/view-whitelist` },
            { label: "Search DND-Blist-Wlist", to: `${urlPrefix}/search-blacklist-dnd` },
        ],
    },
    {
        label: "Flash Messages",
        icon: "fa fa-bell",
        to: "/flash-messages",
    },
    {
        label: "API Docs",
        icon: "fa fa-book",
        children: [
            { label: "Sheet Content", icon: "fa fa-file-text", to: `${urlPrefix}/superadmin-api-docs/sheet-content` },
            { label: "Upload Document", icon: "fa fa-upload", to: `${urlPrefix}/superadmin-api-docs/upload-document` },
        ],
    },
];

export const filterSubSuperAdminMenuByPermission = (menu, permissions) => {
    if (!menu || !permissions) return [];

    const alwaysVisible = new Set(["Dashboard"]);

    return menu
        .map((item) => {
            if (alwaysVisible.has(item.label)) {
                return item;
            }

            const permission = permissions[item.label];
            if (!permission || !permission.view_permission) {
                return null;
            }

            if (item.children) {
                const filteredChildren = item.children
                    .map((child) => {
                        const childPermission = permission.children?.find(
                            (p) => Object.keys(p)[0] === child.label
                        );

                        const childData = childPermission?.[child.label];

                        if (!childData || !childData.view_permission) {
                            return null;
                        }

                        return child;
                    })
                    .filter(Boolean);

                if (filteredChildren.length === 0) return null;

                return {
                    ...item,
                    children: filteredChildren,
                };
            }

            return item;
        })
        .filter(Boolean);
};

export const filterNavDataForSuperAdminOrSub = (urlPrefix, isSubSuperAdmin, permissions) => {
    const menu = getSuperAdminMenu(urlPrefix);

    if (!isSubSuperAdmin) return menu;
    return filterSubSuperAdminMenuByPermission(menu, permissions);
}